import HttpMessage, { ROOT_URL } from './HttpMessage';

class SubscribersService {

  static async subscribe(subscription) {
    const message = {
      route: `${ROOT_URL}/subscribers/subscribe`,
      method: 'POST',
      body: JSON.stringify(subscription),
      header: null
    };

    const data = await HttpMessage.sendMessage(message);
    return { success: data.status === 'success', errorCode: data.errorCode };
  }

  static async unsubscribe(subscription) {
    const message = {
      route: `${ROOT_URL}/subscribers/unsubscribe`,
      method: 'POST',
      body: JSON.stringify(subscription),
      header: null
    };

    const data = await HttpMessage.sendMessage(message);
    return { success: data.status === 'success', errorCode: data.errorCode };
  }

  static async confirmSubscription(subscription) {
    const message = {
      route: `${ROOT_URL}/subscribers/confirmSubscription`,
      method: 'POST',
      body: JSON.stringify(subscription),
      header: null
    };

    const data = await HttpMessage.sendMessage(message);
    return { success: data.status === 'success', errorCode: data.errorCode };
  }

  static async confirmUnsubscription(subscription) {
    const message = {
      route: `${ROOT_URL}/subscribers/confirmUnsubscription`,
      method: 'POST',
      body: JSON.stringify(subscription),
      header: null
    };

    const data = await HttpMessage.sendMessage(message);
    return { success: data.status === 'success', errorCode: data.errorCode };
  }
}

export default SubscribersService;
